import { encryptData, decryptData } from "./helpers";

/* ==================== Storage Utility ==================== */

const STORAGE_PREFIX = "personalia-";

/**
 * Encrypted storage utility that wraps localStorage with encryption
 */
export const encryptStorage = {
  setItem(key: string, value: unknown): void {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const encrypted = encryptData(JSON.stringify(value));
    localStorage.setItem(storageKey, encrypted);
  },

  getItem<T = unknown>(key: string): T | null {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const encrypted = localStorage.getItem(storageKey);
    if (!encrypted) return null;

    try {
      const decrypted = decryptData(encrypted);
      return decrypted ? (JSON.parse(decrypted) as T) : null;
    } catch {
      localStorage.removeItem(storageKey);
      return null;
    }
  },

  removeItem(key: string): void {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    localStorage.removeItem(storageKey);
  },

  clear(): void {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(STORAGE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  },
};
